import { Component, h, Prop, State } from '@stencil/core';
import { searchVtt, setMarkers, removeOldMarkers } from '../../../player/functions/search-vtt';

@Component({
  tag: 'zeudy-search-bar',
  shadow: false,
})
export class zeudySearchBar {
  /**
   * Props
   */
  @Prop() value: string;
  @Prop() player: any;

  /**
   * State
   */
  @State() markers: any;
  @State() currentMarkerLocation: number = -1;

  /**
   * Handle search event
   * @param value Event
   */
  onSearch(e) {
    this.value = e.detail;

    if ('' === this.value) {
      removeOldMarkers(this.player);
      this.markers = [];
    } else {
      const searchResult = searchVtt(this.player, this.value);
      this.player.config.markers = { enabled: true, points: searchResult };
      this.markers = searchResult;
      setMarkers(this.player, searchResult);
    }
  }

  /**
   * Handle previous arrow key click after search
   */
  onPreviousNav() {
    const prevLocation = this.currentMarkerLocation - 1;
    // previous location is -1
    if (prevLocation < 0) {
      this.currentMarkerLocation = this.markers.length - 1;
    } else {
      this.currentMarkerLocation--;
    }
    this.player.currentTime = this.markers[this.currentMarkerLocation]['time'];
  }

  /**
   * Handle the event where search is hovered or focused
   */
  onFocusChange(focus) {
    if (focus?.detail === true) {
      this.player.config.hideControls = false;
    } else {
      this.player.config.hideControls = this.player.config?.preset?.auto_hide || false;
    }
  }

  /**
   * Handle next arrow key click after search
   */
  onNextNav() {
    const nextLocation = this.currentMarkerLocation + 1;
    if (nextLocation > this.markers.length - 1) {
      this.currentMarkerLocation = 0;
    } else {
      this.currentMarkerLocation++;
    }
    this.player.currentTime = this.markers[this.currentMarkerLocation]['time'];
  }

  render() {
    if (!this.player) return '';
    if (!this.player?.media?.textTracks?.length || this.player?.media?.textTracks?.length === 0) return '';

    const presets = this.player.config.preset;
    const placeholder = presets.search?.placeholder;

    return (
      <zeudy-search-bar-ui
        value={this.value}
        hasNavigation={this.markers?.length > 1}
        placeholder={placeholder}
        onNextNav={() => this.onNextNav()}
        onPreviousNav={() => this.onPreviousNav()}
        onSearch={e => this.onSearch(e)}
        onFocusChange={focus => this.onFocusChange(focus)}
      ></zeudy-search-bar-ui>
    );
  }
}
